import my1 from "./projects/mylibrary/1.png"
import my2 from "./projects/mylibrary/2.png"
import my3 from "./projects/mylibrary/3.png"
import my4 from "./projects/mylibrary/4.png"
import my5 from "./projects/mylibrary/5.png"
import my6 from "./projects/mylibrary/6.png"
import my7 from "./projects/mylibrary/7.png"
import my8 from "./projects/mylibrary/8.png"
import my9 from "./projects/mylibrary/9.png"
import my10 from "./projects/mylibrary/10.png"
import my11 from "./projects/mylibrary/11.png"
import my12 from "./projects/mylibrary/12.png"
// ====================================================
import da1 from "./projects/danone/1.png"
import da2 from "./projects/danone/2.png"
import da3 from "./projects/danone/3.png"
import da4 from "./projects/danone/4.png"
import da5 from "./projects/danone/5.png"
import da6 from "./projects/danone/6.png"
import da7 from "./projects/danone/7.png"
import da8 from "./projects/danone/8.png"
import da9 from "./projects/danone/9.png"
import da10 from "./projects/danone/10.png"
import da11 from "./projects/danone/11.png"
// ===========================================================
import ca1 from "./projects/cabinet/1.jpeg"
import ca2 from "./projects/cabinet/2.jpeg"
import ca3 from "./projects/cabinet/3.jpeg"
import ca4 from "./projects/cabinet/4.jpeg"
import ca5 from "./projects/cabinet/5.jpeg"
import ca6 from "./projects/cabinet/6.jpg"
import ca7 from "./projects/cabinet/7.jpeg"
import ca8 from "./projects/cabinet/8.jpg"
import ca9 from "./projects/cabinet/9.jpg"
import ca10 from "./projects/cabinet/10.jpg"
import ca11 from "./projects/cabinet/11.jpg"
import ca12 from "./projects/cabinet/12.jpeg"
import ca13 from "./projects/cabinet/13.jpg"
import ca14 from "./projects/cabinet/14.jpg"
import ca15 from "./projects/cabinet/15.jpg"
import ca16 from "./projects/cabinet/16.jpg"
import ca17 from "./projects/cabinet/17.jpg"
// ===============================================================
import p1 from "./projects/paneau/1.jpeg"
import p2 from "./projects/paneau/2.jpeg"
import p3 from "./projects/paneau/3.jpeg"
import p4 from "./projects/paneau/4.jpeg"
import p5 from "./projects/paneau/5.jpeg"
import p6 from "./projects/paneau/6.jpeg"
import p7 from "./projects/paneau/7.jpeg"
import p8 from "./projects/paneau/8.jpeg"
import p9 from "./projects/paneau/9.jpeg"
import p10 from "./projects/paneau/10.jpeg"
import p11 from "./projects/paneau/11.jpeg"
import p12 from "./projects/paneau/12.jpeg"
import p13 from "./projects/paneau/13.png"
import p14 from "./projects/paneau/14.png"
import p15 from "./projects/paneau/15.png"
// ==============================================================
import m1 from "./projects/mnist/1.png"
import m2 from "./projects/mnist/2.png"
import m3 from "./projects/mnist/3.png"
import m4 from "./projects/mnist/4.png"
import m5 from "./projects/mnist/5.png"
import m6 from "./projects/mnist/6.png"
import m7 from "./projects/mnist/7.png"
import m8 from "./projects/mnist/8.png"
// ==============================================================
import f1 from "./projects/format/1.png"
import f2 from "./projects/format/2.png"
import f3 from "./projects/format/3.png"
import f4 from "./projects/format/4.png"
import f5 from "./projects/format/5.png"
import f6 from "./projects/format/6.png"
// ==============================================================
import t1 from "./projects/tritement/1.png"
import t2 from "./projects/tritement/2.png"
import t3 from "./projects/tritement/3.png"
import t4 from "./projects/tritement/4.png"
import t5 from "./projects/tritement/5.png"
import t6 from "./projects/tritement/6.png"
// ==============================================================
import h1 from "./projects/hotel/1.png"
import h2 from "./projects/hotel/2.png"
import h3 from "./projects/hotel/3.png"
import h4 from "./projects/hotel/4.png"
import h5 from "./projects/hotel/5.png"
import h6 from "./projects/hotel/6.png"
import h7 from "./projects/hotel/7.png"
import h8 from "./projects/hotel/8.png"
import h9 from "./projects/hotel/9.png"
import h10 from "./projects/hotel/10.png"
// =============================================================
import s1 from "./projects/sms/1.png"
import s2 from "./projects/sms/2.png"
import s3 from "./projects/sms/3.png"

export const mylibrary=[my1,my2,my3,my4,my5,my6,my7,my8,my9,my10,my11,my12]
export const dannone=[da1,da2,da3,da4,da5,da6,da7,da8,da9,da10,da11]
export const cabinet=[ca1,ca2,ca3,ca4,ca5,ca6,ca7,ca8,ca9,ca10,ca11,ca12,ca13,ca14,ca15,ca16,ca17]
export const paneau=[p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,p15]
export const mnist=[m1,m2,m3,m4,m5,m6,m7,m8]
export const format=[f1,f2,f3,f4,f5,f6]
export const traitement=[t1,t2,t3,t4,t5,t6]
export const hotel=[h1,h2,h3,h4,h5,h6,h7,h8,h9,h10]
export const sms=[s1,s2,s3]